(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ProfileDialogController', ProfileDialogController);

    ProfileDialogController.$inject = ['$timeout', '$scope', '$rootScope', '$state', '$window', '$stateParams', '$q', 'DataUtils', 'entity', 'Profile', 'Company', 'Collectivity', 'Principal', 'Picture', 'ModerationProfile', 'Whoswho'];

    function ProfileDialogController($timeout, $scope, $rootScope, $state, $window, $stateParams, $q, DataUtils, entity, Profile, Company, Collectivity, Principal, Picture, ModerationProfile, Whoswho) {
        var vm = this;

        vm.profile = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        vm.organizationsNoResults = false;
        vm.getOrganizations = getOrganizations;

        vm.addCurrentPosition = addCurrentPosition;
        vm.addPastPosition = addPastPosition;

        vm.setActive = setActive;
        vm.setInActive = setInActive;

        vm.profilesNoResults = false;
        vm.getProfiles = getProfiles;

        vm.isAdmin = isAdmin;
        vm.deleteProfile = deleteProfile;

        vm.grade = "";

        vm.editForm;

        vm.currentAccount = null;

        vm.departements = Whoswho.getDepartements();

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        $timeout(function() {
            loadPicture(vm.profile);
            if (vm.profile.grade){
                vm.grade = vm.profile.grade.toString();
            }

            $scope.$parent.vm.selectedContribution = "new-profile";
            angular.element('.form-group:eq(0)>input').focus();
            if (entity.id) {
                $scope.$parent.vm.edit = true;
            }
            if (vm.profile.positions) {
                vm.currentPositions = vm.profile.positions.filter(function(val) {
                    return val.active == true;
                });

                vm.pastPositions = vm.profile.positions.filter(function(val) {
                    return val.active == false;
                });
            } else {
                vm.currentPositions = [];
                vm.pastPositions = [];
                addCurrentPosition();
            }

        });

        function isAdmin() {
            return Principal.hasAnyAuthority(['ROLE_ADMIN']);
        }

        function addCurrentPosition() {
            vm.currentPositions.push({ "active": true });
        }

        function addPastPosition() {
            vm.pastPositions.push({ "active": false });
        }


        function setActive(index) {
            var position = vm.pastPositions[index];
            position.active = true;
            vm.pastPositions.splice(index, 1)
            vm.currentPositions.push(position);
        }

        function setInActive(index) {
            var position = vm.currentPositions[index];
            position.active = false;
            vm.currentPositions.splice(index, 1)
            vm.pastPositions.push(position);
        }

        function clear() {
            $scope.$parent.$dismiss();
        }

        function save() {
            vm.isSaving = true;

            vm.profile.positions = vm.currentPositions.concat(vm.pastPositions);

            for (var i = 0; i < vm.profile.positions.length; i++) {
                if (vm.profile.positions[i].superior == "") {
                    vm.profile.positions[i].superior = null;
                }
            }
            // if (isAdmin() || vm.profile.mine || vm.profile.myContribution) {
                if (vm.profile.id !== null) {
                    if (vm.profile.moderationId) {
                        // Update du profile à partir de la modération
                        ModerationProfile.updateAndApprove({ id: vm.profile.moderationId }, vm.profile, onSaveSuccess, onSaveError);
                    } else {
                        Profile.update(vm.profile, onSaveSuccess, onSaveError);
                    }
                } else {
                    if (vm.profile.moderationId) {
                        // Création du profile à partir de la modération
                        ModerationProfile.createAndApprove({ id: vm.profile.moderationId }, vm.profile, onSaveSuccess, onSaveError);
                    } else {
                        Profile.save(vm.profile, onSaveSuccess, onSaveError);
                    }
                }
            /*
            } else {
                // Création d'une modération si non admin/profile non crée par l'utilisateur
                var mProfile = Object.assign({}, vm.profile);
                mProfile['mPositions'] = mProfile.positions;
                mProfile.positions = null;
                mProfile['grade'] = vm.grade;
                if (vm.profile.id !== null) {
                    mProfile['referencedProfile'] = Object.assign({}, vm.profile);
                    mProfile.id = null;
                    ModerationProfile.mupdate(mProfile, onModerationSaveSuccess, onSaveError);
                } else {
                    ModerationProfile.msave(mProfile, onModerationSaveSuccess, onSaveError);
                }
            }
            */
        }

        function deleteProfile() {
            vm.isSaving = true;
            if (vm.profile.id !== null) {
                Profile.delete({
                    id: vm.profile.id
                }, onDeleteSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('quilinkApp:profileUpdate', result);
            $rootScope.$broadcast('quilinkApp:profileUpdate', result);
            vm.isSaving = false;
            $scope.$parent.$close();
        }


        function onModerationSaveSuccess(result) {
            $scope.$emit('quilinkApp:moderationProfileUpdate', result);
            $rootScope.$broadcast('quilinkApp:moderationProfileUpdate', result);
            vm.profile.hasModeration = true;
            vm.isSaving = false;
            $scope.$parent.$close();
        }

        function onDeleteSuccess(result) {
            $scope.$emit('quilinkApp:profileUpdate', null);
            $rootScope.$broadcast('quilinkApp:profileUpdate', null);
            vm.isSaving = false;
            $window.location.href = '/';
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        vm.setPicture = function($file, profile) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        profile.picture = base64Data;
                        profile.pictureContentType = $file.type;
                    });
                });
            }
        };

        function getProfiles(q) {
            return Profile.search({ query: q }).$promise.then(function(profiles) {
                vm.profilesNoResults = profiles.length === 0;
                return profiles;
            });
        }

        function getOrganizations(q) {
            return Company.search({ query: q }).$promise.then(function(companies) {
                return Collectivity.search({ query: q }).$promise.then(function(collectivities) {
                    var organizations = companies.concat(collectivities);
                    if (isAdmin()) {
                        organizations.map( function(org) {
                            if (org.equipeCommerciale) {
                                org.name = org.name + ' (' + org.equipeCommerciale.name+ ')'
                            }
                        });
                    }
                    return organizations;
                });
            });
        }


        function loadPicture(profile) {
            if (profile.pictureContentType) {
                Picture.getProfilePicture(profile.id).then(function(response) {
                    profile.picture = response;
                }, function(response) {
                    console.log(response);
                });
            }
        }

    }
})();
